jQuery( document ).ready(function($) {
    if (!$('body').hasClass('wp-admin')) {
        var mediumBreakpoint = parseInt(getComputedStyle(document.body).getPropertyValue('--uk-breakpoint-m')) <= $(window).width();
        if (mediumBreakpoint) {
            // check if deep link
            var baseElement = $('.ct_referenzen.slider')
            var jumpid = baseElement.attr('data-jumpid');
            if (jumpid) {
                var jumpIndexItem = $('.ct_referenzen.slider').find('[data-item-id=' + jumpid + ']');
                if (jumpIndexItem) {
                    var targetIndex = parseInt(jumpIndexItem.attr('data-index'));
                    var targetTermId = parseInt(jumpIndexItem.attr('data-term-id'));
                    ScrollToElement(baseElement);
                    setTimeout(function () {
                        InitSlideInline(targetIndex, targetTermId);
                    }, 500);
                }
            } else {
                InitSlideInline(0);
            }

            $(".ct_referenzen.default a").click(function (e) {
                e.preventDefault();

                var targetTermId = parseInt($(this).attr('data-item-id'));
                if (targetTermId > 0) {
                    // find first slide
                    var slide = $('.ct_referenzen.slider').find('[data-term-id=' + targetTermId + ']').first();
                    if (slide) {
                        targetIndex = parseInt(slide.attr('data-index'));
                        var slider = $('.ct_referenzen .inlineSlider').first();
                        slider.slick('slickGoTo', targetIndex, false);
                    }
                }
            });

            function InitSlideInline($initSlide = 0, $updateCategory = false) {
                var slider = $('.ct_referenzen .inlineSlider').first();

                slider
                    .on('beforeChange', function (event, slick, currentSlide, nextSlide) {
                        var direction = 'right';
                        if ((currentSlide > nextSlide && (nextSlide !== 0 || currentSlide === 1)) || (currentSlide === 0 && nextSlide === slick.slideCount - 1)) {
                            direction = 'left';
                        }

                        for (var i = 0; i < slick.$slides.length; i++) {
                            var $slide = jQuery(slick.$slides[i]);
                            if ($slide.hasClass('slick-active')) {
                                $slide.addClass('is-current').addClass('in-transition').addClass(direction);
                                $slide.prev().addClass('in-transition').addClass(direction);
                                $slide.next().addClass('in-transition').addClass(direction);
                                $slide.next().next().addClass('upcoming-next').addClass('in-transition').addClass(direction);
                                $slide.prev().prev().addClass('upcoming-prev').addClass('in-transition').addClass(direction);
                                break;
                            }
                        }
                    })
                    .on('init reInit afterChange', function (event, slick) {
                        if (event.type !== 'afterChange') {
                            setTimeout(function () {
                                slick.$slider.addClass('is-visible');
                            }, 700);
                        }

                        slick.$slider.find('.slick-slide')
                            .removeClass('prev').removeClass('next')
                            .removeClass('left').removeClass('right')
                            .removeClass('upcoming-prev').removeClass('upcoming-next')
                            .removeClass('in-transition')
                            .removeClass('is-current');

                        for (var i = 0; i < slick.$slides.length; i++) {
                            var $slide = jQuery(slick.$slides[i]);
                            if ($slide.hasClass('slick-active')) {
                                // update DOM siblings
                                $slide.prev().addClass('prev');
                                $slide.next().addClass('next');
                                break;
                            }
                        }

                        UpdateCounterInline(slick.currentSlide + 1, slick.slideCount);
                        var termId = jQuery(this).find('.slick-current').attr('data-term-id');
                        UpdateCategory(termId);
                    })
                    .slick({
                        centerMode: true,
                        speed: 700,
                        draggable: false,
                        initialSlide: $initSlide,
                        nextArrow: '<span class="slick-next"><i class="fal fa-chevron-right"></i></span>',
                        prevArrow: '<span class="slick-prev"><i class="fal fa-chevron-left"></i></span>'
                    });
                if ($updateCategory) {
                    UpdateCategory($updateCategory);
                }
            }

            function UpdateCounterInline($currentItem, $totalItems) {
                var counter = $('.ct_referenzen.slider .counter').first();
                if (counter) {
                    counter.text($currentItem + ' / ' + $totalItems);
                }
            }

            function UpdateCategory(itemTermId) {
                var sliderNavigation = jQuery('.ct_referenzen.default ul');
                var activeNavigationItem = sliderNavigation.find('li.active');
                var activeNavigationItemTermId = parseInt(activeNavigationItem.find('a').first().attr('data-item-id'));

                if (itemTermId !== activeNavigationItemTermId) {
                    activeNavigationItem.removeClass('active');
                    var newActiveNavigationItem = sliderNavigation.find(`[data-item-id='${itemTermId}']`);
                    newActiveNavigationItem.parent().addClass('active');
                }
            }
        }
        else {
            var modalContent = $('.ct_referenzen.default .modalTemplate');
            CheckOpenModalDialog($(".ct_referenzen.default a"), 'ct_referenzen', modalContent)
            CheckDeepLink($('.ct_referenzen.default ul'), 'ct_referenzen', modalContent, false, 'data-jumpid-mobile', 'data-item-id-mobile');
        }
    }
});